<template>
  <span class="tooltip-container" :style="{top: topOffset, left: leftOffset}">
    <span class="tooltip-tip" style="opacity: 1">
      <span class="tooltip-tip__arrow"></span>
      <span class="tooltip-tip__text">
        ЭП: Мобильная ЭП <br>
        Дата: 23-07-2019
      </span>
    </span>
  </span>
</template>

<script>
  export default {
    props: {
      top: Number,
      left: Number
    },

    computed: {
      topOffset() {
        return this.top ? (this.top - 15) + 'px': undefined
      },

      leftOffset() {
        return this.left ? this.left + 'px': undefined
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tooltip-container {
    z-index: 8900;
    transform: translate(-50%, -100%);
  }
</style>
